import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";

import { Document } from "src/app/parametrage/core/model/document";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { DocumentService } from "src/app/parametrage/core/service/document.service";
import { UploadInPieceComponent } from "src/app/formulaire/modal/upload-in-piece/upload-in-piece.component";
import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { RemplacerFichierComponent } from "src/app/formulaire/modal/remplacer-fichier/remplacer-fichier.component";
import { RenommerFichierComponent } from "src/app/formulaire/modal/renommer-fichier/renommer-fichier.component";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { OfficeViewerModalComponent } from "src/app/formulaire/modal/viewer/office-viewer-modal/office-viewer-modal.component";
import { PdfViewerModalComponent } from "src/app/formulaire/modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component";
import { ImageViewerModalComponent } from "src/app/formulaire/modal/viewer/image-viewer-modal/image-viewer-modal.component";
import { DocViewerModalComponent } from "src/app/formulaire/modal/viewer/doc-viewer-modal/doc-viewer-modal.component";
import { RetournerDossierModalComponent } from 'src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component';

@Component({
  selector: "app-form-scan-piece",
  templateUrl: "./form-scan-piece.component.html",
  styleUrls: ["./form-scan-piece.component.scss"],
})
export class FormScanPieceComponent implements OnInit {
  pressButton: Boolean = false;

  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  documents: Document[];
  documentsObligatoire: Document[];

  fichiers: SubItemCheckedDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _gestionFichierService: GestionFichierService,
    private _documentService: DocumentService,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.fichierAFournirNotUploadedPrticulier(this.requestId);
      this.getPiecesClient(this.requestId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  retourner()
  {
    const modalRef = this.modalService.open(RetournerDossierModalComponent,{centered:true});
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then((data) => {
      // on close
      if(data != "Close click"){
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      }
        
      }, (reason) => {
      // on dismiss
      });

  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  fichierAFournirNotUploadedPrticulier(requestId) {
    this._documentService
      .fichierAFournirNotUploadedParticulier(requestId)
      .subscribe(
        (data) => {
          this.documents = data.sort((a, b) => (a.label > b.label ? 1 : -1));
          this.documentsObligatoire = this.documents.filter(
            (t) => t.obligatoire == true
          );
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getPiecesClient(requestId) {
    this._gestionFichierService.getPiecesClient(requestId).subscribe(
      (data) => {
        this.fichiers = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInPieceComponent, {
      centered: true,
      size: "lg",
    });

    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        // on close
        this.fichierAFournirNotUploadedPrticulier(this.requestId);
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  remplacerFichier(subitemId, name, displayname) {
    const modalRef = this.modalService.open(RemplacerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.codeDocument = name.split(".")[0];
    modalRef.componentInstance.displayname = displayname;

    modalRef.result.then(
      (data) => {
        // on close
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  renommerFichier(subitemId) {
    const modalRef = this.modalService.open(RenommerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteFile(subItemId) {
    if (confirm("Press a button!")) {
      this._gestionFichierService.delete(subItemId).subscribe(
        (data) => {
          this.getPiecesClient(this.requestId);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  /** */

  fileViewer(subitem: SubItem): void {
    const fileTab = subitem.name.split(".");
    const fileExtension = fileTab[fileTab.length - 1];

    if (fileExtension.toLowerCase() == "pdf") {
      this.pdfViewer(subitem.id);
    } else if (
      fileExtension.toLowerCase() == "png" ||
      fileExtension.toLowerCase() == "jpeg" ||
      fileExtension.toLowerCase() == "jpg"
    ) {
      this.imageViewer(subitem.id);
    } else {
      this.officeViewer(subitem.id);
    }
  }

  officeViewer(subitemId): void {
    const modalRef = this.modalService.open(OfficeViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  imageViewer(subitemId): void {
    const modalRef = this.modalService.open(ImageViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  docViewer(subitemId): void {
    const modalRef = this.modalService.open(DocViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
